<template>
  <div>
    <v-container>
      <v-alert
        type="info"
        text
        outlined
      >
        <span v-html="$t('page.list.infoBox')" />
      </v-alert>
    </v-container>
    <pv-exams-import-report-alert :import-info-id="importInfoId" />
    <template v-if="isTelcUser || isBamfUser">
      <pv-telc-user-list />
    </template>
    <template v-else>
      <pv-customer-list />
    </template>

    <pv-import-exams-dialog
      name="import-exams-dialog"
    />
  </div>
</template>

<script>

import pvExamsImportReportAlert from '@/components/ExamsImportReportAlert';
import pvCustomerList from '@/components/CustomerList';
import pvTelcUserList from '@/components/TelcUserList';
import pvImportExamsDialog from '@/components/dialogs/ImportExams';

export default {
  name: 'List',

  components: {
    pvExamsImportReportAlert,
    pvCustomerList,
    pvTelcUserList,
    pvImportExamsDialog
  },

  props: {
    importInfoId: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
.v-data-table {
  background-color: transparent !important;

  & > .v-data-table__wrapper {
    padding-top: 2rem;
    margin-top: 2rem;
    border-top: $border-width-root solid map-get($custom-colors, "grey");
  }

  tbody tr {
    td {
      .table-cell {
        &.actions a {
          text-decoration: none;
          padding-left: 2rem;
        }

        .table-cell-min-width {
          min-width: 300px !important;
        }
      }
    }

    &:not(.v-data-table__mobile-table-row) {
      background-color: transparent !important;

      &:hover {
        .table-cell {
          background-color: darken(map-get($custom-colors, "lightgrey"), 7%) !important;

          &.actions {
            background-color: darken(map-get($custom-colors, "lightgrey"), 10%) !important;
          }
        }
      }

      td {
        border-bottom: none !important;
        padding: 0 !important;
        height: 72px !important;

        .table-cell {
          overflow: hidden;
          position: relative;
          display: flex;
          align-items: center;
          padding: 8px 15px;
          margin-bottom: 15px;
          background-color: map-get($custom-colors, "lightgrey");
          transition: background-color 0.2s;
          height: 57px;

          &.has-validation-error {
            background-color: lighten(map-get($custom-colors, "error"), 35%);
            border-color: #a81411;
            border: 1;
          }

          &.has-fatal-validation-error {
            background-color: lighten(map-get($custom-colors, "error"), 25%);
          }

          &.actions {
            background-color: darken(map-get($custom-colors, "lightgrey"), 3%);

            &.has-validation-error {
              background-color: darken(lighten(map-get($custom-colors, "error"), 35%), 3%);
            }

            &.has-fatal-validation-error {
              background-color: darken(lighten(map-get($custom-colors, "error"), 25%), 3%);
            }

            padding: {
              left: 0;
              right: 0;
            }

            &,
            & > span {
              display: flex;
              align-items: center;
              justify-content: center;
            }

            a {
              padding: 0.25rem 1rem;
              display: inline-flex;
              align-items: center;

              &:not(:last-of-type) {
                border-right: $border-width-root solid map-get($custom-colors, "white");
              }
            }
          }

          &-inner {
            display: flex;
            align-items: center;
            max-width: 400px;

            span:first-of-type {
              display: block;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }

            .table-cell-line-wrap {
              white-space: normal !important;
            }

            &.single-button span {
              border-right: none !important;
            }
          }
        }
      }
    }
  }

  .v-data-table-header tr th {
    border-bottom: none !important;
    color: map-get($custom-colors, "black") !important;
    vertical-align: top;

    .v-data-table-header__icon {
      margin-left: 0.5rem;
    }
  }
}

//-----------------------------------------------------
// Workarounds to fix the data table footer in IE 11.
//-----------------------------------------------------
.v-data-footer__select {
  flex-basis: auto !important;
}

.v-data-footer__select .v-select {
  flex-basis: 50px !important;
}

.v-data-footer__select .v-select .v-select__selections {
  flex-basis: auto;
  min-width: 25px;
}

.v-list-item__content {
  flex: 1 1 auto;
  min-width: 50px;
}
</style>
